// Module
var code = `<div class="account-picker">
  <div class="filters">
    <div  ng-if="\$ctrl.includeCustomer" class="labelled-field labelled-field--long">
      <label>Customer name</label>
      <input type="text"
             ng-model="\$ctrl.customerName"
             ng-keydown="\$event.which === 13 && \$ctrl.search()"
             autocomplete="off">
    </div>
    <div class="labelled-field labelled-field--long">
      <label>Account number</label>
      <input type="text"
             ng-model="\$ctrl.productNumber"
             ng-keydown="\$event.which === 13 && \$ctrl.search()"
             autocomplete="off">
    </div>

    <button class="btn btn-primary search-button" ng-click="\$ctrl.search()">Search</button>
  </div>

  <div class="picker-content" ng-show="\$ctrl.visible">
    <table ng-show="\$ctrl.searchResults.length > 0" class="table table--last-column-to-right">
      <thead>
        <tr>
          <th class="th--index">#</th>
          <th>Account number</th>
          <th>Account name</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="result in \$ctrl.searchResults">
          <td>{{\$index + 1 }}.</td>
          <td>{{result.productNumber}}</td>
          <td>{{result.productName}}</td>
          <td>{{result.status}}</td>
          <td class="table__actions">
            <a ng-click="\$ctrl.choose(result, \$event)" class="btn btn-primary">Choose</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="no-results" ng-show="\$ctrl.searchResults.length == 0">
      No accounts have been found.
    </div>
  </div>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/common/account-picker.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;